import { render } from "./PcClinicRegionSelect.vue?vue&type=template&id=5f626dec&scoped=true"
import script from "./PcClinicRegionSelect.vue?vue&type=script&lang=js"
export * from "./PcClinicRegionSelect.vue?vue&type=script&lang=js"

import "./PcClinicRegionSelect.vue?vue&type=style&index=0&id=5f626dec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f626dec"]])

export default __exports__